import { FaqsAccordion } from "@/components/ui/faqs-accordion";

const HOME_FAQS = [
  {
    question: "Does my bank statement get sent to your server?",
    answer:
      "No. Conversion runs entirely inside your browser tab using JavaScript. Your PDF is never transmitted over the network. You can disconnect your internet after the page loads and it still works.",
  },
  {
    question: "My bank gives me a CSV export. Why do I need this?",
    answer:
      "If your bank gives you a clean CSV, use that — it's faster. BankConvert is for the cases where you only have a PDF: statements from accountants, older accounts, third-party records, or banks that don't offer data exports.",
  },
  {
    question: "Can't I just drag my PDF into ChatGPT?",
    answer:
      "Yes, that's a real alternative. The difference: ChatGPT sends your bank data to OpenAI's servers. BankConvert processes locally in your browser — nothing leaves your device. It's also faster and more consistent for repeated use.",
  },
  {
    question: "How accurate is it?",
    answer:
      "Very accurate on clean, text-based PDFs from major banks. Our parser extracts every row — dates, payees, debits, credits, and running balance. Scanned or image-based PDFs won't work because we don't use OCR. If you can select text in your PDF viewer, it will work here.",
  },
  {
    question: "Do I need to create an account to try it?",
    answer:
      "You need a free account to download the Excel file. You get 5 free conversions — no credit card required.",
  },
  {
    question: "How do I delete my account?",
    answer:
      "Go to Settings → Account → Delete Account. This removes your email, conversion history, and subscription. Since your PDFs are never stored on our servers, there's nothing else to delete on our end.",
  },
];

export default function HomeFaq() {
  return (
    <FaqsAccordion
      title="Common questions"
      description="Honest answers to the things people actually want to know before trying."
      faqs={HOME_FAQS}
    />
  );
}
